import React from 'react';
import AntBase from 'antd-core/es/typography/Base';

const INTERNAL_TypographyBase = React.forwardRef((props, ref) => {
    return React.createElement(AntBase, Object.assign({ ref: ref }, props));
});

export { INTERNAL_TypographyBase };
//# sourceMappingURL=Base.js.map
